





















import { Vue, Component } from "vue-property-decorator";

export interface ModelOptions {
  width: number;
  value: boolean;
  title: string;
  message: string;
  successText: string;
  cancelText: string;
  callback?: (value: boolean) => {} | undefined;
  refund: number;
}

@Component
export default class Modal extends Vue {
  option: ModelOptions = {
    width: 330,
    value: false,
    title: "",
    message: "",
    successText: "Submit",
    cancelText: "Cancel",
    refund: 0
  };

  resolve: (value?: any) => void = () => {};
  reject: (reason?: any) => void = () => {};

  beforeMount() {
    document.body.appendChild(this.$el);
  }

  open(option: ModelOptions) {
    option.value = true;
    this.option = Object.assign(this.option, option);
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
  changeRefund() {
    return this.option.refund;
  }

  submit() {
    this.resolve(true);
    this.option.value = false;
    // this.destroy();
  }
  close() {
    this.resolve(false);
    this.option.value = false;
    // this.destroy();
  }
  destroy() {
    this.$destroy();
    this.removeElement(this.$el);
  }
  removeElement(el: Element) {
    if (typeof el.remove !== "undefined") {
      el.remove();
    } else {
      el.parentNode ? el.parentNode.removeChild(el) : "";
    }
  }
}
